'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PROJECT = exports.ENV_TYPE = exports.AUTH_ZONE = exports.ALERT_LEVEL = exports.setCustomDimensions = exports.trackPageview = exports.trackEvent = exports.feLog = exports.analyticsInit = undefined;

var _Analytics = require('./Analytics');

var _Analytics2 = _interopRequireDefault(_Analytics);

var _alertLevel = require('./alertLevel');

var _alertLevel2 = _interopRequireDefault(_alertLevel);

var _authZone = require('./authZone');

var _authZone2 = _interopRequireDefault(_authZone);

var _envType = require('./envType');

var _envType2 = _interopRequireDefault(_envType);

var _project = require('./project');

var _project2 = _interopRequireDefault(_project);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isInitialized = function isInitialized() {
    if (typeof window === 'undefined') {
        return false;
    }

    if (!window.zgRentalsAnalytics) {
        console.error('You have not called analyticsInit. Please instantiate analytics by calling analyticsInit');
        return false;
    }

    return true;
};

/**
 * Initialize google tag manager for tracking google analytics by appending init scripts to <head>
 * @param {string} az - authZone 'zillow', 'trulia', or 'hotpads'
 * @param {string} env - environment defaults to 'TEST' if none supplied
 */
var analyticsInit = function analyticsInit() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var az = options.az,
        project = options.project,
        env = options.env;
    // if server rendering, then don't run

    if (typeof window === 'undefined') {
        return;
    }

    // if init has already been run, don't run again
    if (window.zgRentalsAnalytics) {
        return;
    }

    var projectConfig = _project2.default[project];

    if (!projectConfig) {
        throw new Error('A valid project was not provided to initialize analytics.');
    }

    var config = {
        az: az,
        env: env,
        feLogUrl: projectConfig.feLogUrl
    };

    console.log('initializing GA with authZone: ' + az + ', project: ' + project + ', environment: ' + env);

    var analytics = new _Analytics2.default(config);
    analytics.initialize();
    window.zgRentalsAnalytics = analytics;
};

/**
 * Track page view
 * @param {object} data - page view event data in the format: { action, label, value } where all fields are optional
 */
var trackPageview = function trackPageview(data) {
    if (!isInitialized()) {
        return;
    }

    console.log('tracking page view. authZone: ' + window.zgRentalsAnalytics.az + ', data: ', data);
    window.zgRentalsAnalytics.trackPageview(data);
};

/**
 * Track event
 * @param {object} data - event data in the format: { event, category, action, label, value }
 * where 'event' is required and other fields are optional.
 */
var trackEvent = function trackEvent() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (!isInitialized()) {
        return;
    }

    console.log('tracking event. authZone: ' + window.zgRentalsAnalytics.az + ', data: ', data);
    window.zgRentalsAnalytics.trackEvent(data);
};

/**
 * Log frontend error
 * @param {object} payload - error data in the format: { page, event, errorMessage, stacktrace }
 * where 'errorMessage' is required and other fields are optional.
 */
var feLog = function feLog() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        alertLevel = _ref.alertLevel,
        page = _ref.page,
        event = _ref.event,
        message = _ref.message,
        stacktrace = _ref.stacktrace,
        meta = _ref.meta;

    if (!isInitialized()) {
        return;
    }

    if (!message) {
        console.error('payload.message is required');
        return;
    }

    window.zgRentalsAnalytics.logFeInfo({ alertLevel: alertLevel, page: page, event: event, message: message, stacktrace: stacktrace, meta: meta });
};

/**
 * Set custom dimension
 * @param {object} data - cusotm dimension data in the format: { dimension<Index>: dimension_name }
 * where <Index> is a number representing the index of the custom metric.
 */
var setCustomDimensions = function setCustomDimensions(data) {
    if (!isInitialized()) {
        return;
    }

    console.log('Setting custom dimension. authZone: ' + window.zgRentalsAnalytics.az + ', data: ', data);
    window.zgRentalsAnalytics.setCustomDimensions(data);
};

exports.analyticsInit = analyticsInit;
exports.feLog = feLog;
exports.trackEvent = trackEvent;
exports.trackPageview = trackPageview;
exports.setCustomDimensions = setCustomDimensions;
exports.ALERT_LEVEL = _alertLevel2.default;
exports.AUTH_ZONE = _authZone2.default;
exports.ENV_TYPE = _envType2.default;
exports.PROJECT = _project2.default;
//# sourceMappingURL=index.js.map